import {View} from 'MWC';
import tpl from '../templates/TabsNew.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            modes: props.modes,
            mode: props.initTab ? props.modes[+props.initTab].mode : props.modes[0].mode
        };
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);

        this.toggleMode = this.toggleMode.bind(this);
        return this;
    }

    play() {
        this.slider.slickPlay();
    }
    pause() {
        this.slider.slickPause();
    }

    toggleMode = (e, mode) => {
        const target = e.target;
        this.setState({mode: mode || target.name});
        if (this.props.toggle) {
            this.props.toggle(mode || target.name);
        }
        if (this.slider) {
            this.pause();
            this.play();
        }
    };

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
